var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewArrowLeftColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/arrow-left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.65 4.43337L8.97499 7.10837L7.33333 8.7417C6.64166 9.43337 6.64166 10.5584 7.33333 11.25L11.65 15.5667C12.2167 16.1334 13.1833 15.725 13.1833 14.9334V10.2584V5.0667C13.1833 4.2667 12.2167 3.8667 11.65 4.43337Z",
    fill: "#6933FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewArrowLeftColored);
export default __webpack_public_path__ + "static/media/new-arrow-left-colored.1d6c058a13f2c7c34a81b8b096307187.svg";
export { ForwardRef as ReactComponent };